import React, {useState, useEffect, useRef} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import ApiService from "../util/ApiService";
import CustomPagination from "../util/CustomPagination";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from "sweetalert2";
import Switch from "react-switch"; // Importando o JS do Bootstrap

require("./assets/css/Department.css");

const DepartmentEditModal = ({show, onHide, department, actionText = "Salvar"}) => {

    const selectInputRef = useRef();
    const [specialtyOptions, setSpecialtyOptions] = useState([]);

    const [departmentData, setDepartmentData] = useState({
        id: "",
        name: "",
        description: "",
        status: 1,
        value: null,
        is_standard: false,
        specialties: []
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (department?.id) {
            setDepartmentData(department);

            const selectedSpecialties = (department.specialties_department || [])
                .filter(item => item.specialty) // evita erro se specialty estiver nulo
                .map(item => ({
                    value: item.specialty.id,
                    label: item.specialty.name
                }));

            // Atualiza os dados do departamento
            setDepartmentData({
                ...department,
                specialties: selectedSpecialties
            });
        } else {
            setDepartmentData({
                id: "",
                name: "",
                description: "",
                status: 1,
                value: null,
                is_standard: false,
                specialties: []
            });
        }
    }, [department]);


    useEffect(() => {

        if(show) {
            fetchSpecialties();
        }

    }, [show]);


    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setDepartmentData({...departmentData, [name]: value});
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            let response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/register`,
                departmentData,
                true
            );

            if (response?.code === 200) {
                Swal.fire("Sucesso", "Departamento salvo com sucesso!", "success").then(() => {
                    onHide(true);
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false); // Finaliza o carregamento
        }
    };

    const handleRadioChange = (e) => {
        const useValue = e.target.value === 'yes';
        setDepartmentData({
            ...departmentData,
            value: useValue ? 0 : null,
        });
    };


    const fetchSpecialties = async () => {
        try {

                const response = await ApiService.send('get', `${process.env.REACT_APP_URL_API}specialties/list`);

                const {data} = ApiService.handleApiResponse(response);

                const options = data.map(specialty => ({
                    value: specialty.id,
                    label: specialty.name,
                }));

                setSpecialtyOptions(options);

        } catch (error) {
            ApiService.handleApiError(error);
        }
    };


    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{department?.id ? "Editar Departamento" : "Cadastrar Departamento"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className=" p-3">
                    <div className="mb-3">
                        <label className="form-label">Nome</label>
                        <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={departmentData.name}
                            onChange={handleInputChange}
                            placeholder="Digite o nome do departamento"
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Descrição</label>
                        <textarea
                            className="form-control"
                            name="description"
                            value={departmentData.description}
                            onChange={handleInputChange}
                            placeholder="Digite uma descrição"
                        />
                    </div>
                    <div className="col-12 form-group">
                        <label>Especialidades</label>
                        <Select
                            isMulti
                            ref={selectInputRef}
                            value={departmentData.specialties || []}
                            onChange={(selectedOptions) =>
                                setDepartmentData({
                                    ...departmentData,
                                    specialties: selectedOptions || []
                                })

                            }
                            options={specialtyOptions}
                            placeholder="Selecione"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({...base, zIndex: 9999}),
                                menu: base => ({...base, zIndex: 9999}),
                            }}
                        />

                    </div>


                    <div className="mb-3">
                        <label className="form-label">Usar Valor por Hora?</label>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="useValue"
                                value="yes"
                                id="useValueYes"
                                checked={departmentData.value !== null}
                                onChange={handleRadioChange}
                            />
                            <label className="form-check-label" htmlFor="useValueYes">
                                Sim
                            </label>
                        </div>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="useValue"
                                value="no"
                                id="useValueNo"
                                checked={departmentData.value === null}
                                onChange={handleRadioChange}
                            />
                            <label className="form-check-label" htmlFor="useValueNo">
                                Não
                            </label>
                        </div>
                        {departmentData.value !== null && (
                            <>
                                <label className="form-label">Valor por Hora</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="value"
                                    value={departmentData.value ?? ''}
                                    onChange={handleInputChange}
                                    placeholder="Digite o valor por hora"
                                    disabled={departmentData.value === null}
                                />
                            </>
                        )}
                    </div>
                    <div className="mb-3 col-12 col-xl-6 col-lg-6 mt-2">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h6 className="mb-1">Padrão para todos Usuários</h6>
                                <p className="text-muted mb-0" style={{fontSize: '0.85rem'}}>Padrão para novos cadastros
                                    ou já ativos</p>
                            </div>
                            <Switch
                                className="me-6"
                                checked={departmentData?.is_standard || false}
                                onColor="#0d6efd"
                                onChange={(checked) => setDepartmentData(prev => ({
                                    ...prev,
                                    is_standard: checked
                                }))}
                            />
                        </div>
                    </div>
                    <div className="mb-3 col-12 col-xl-6 col-lg-6 mt-2">
                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <h6 className="mb-1">Situação</h6>
                                <p className="text-muted mb-0" style={{fontSize: '0.85rem'}}>(Ativo ou Não)</p>
                            </div>
                            <Switch
                                className="me-6"
                                checked={departmentData.status || false}
                                onColor="#0d6efd"
                                onChange={(checked) => setDepartmentData(prev => ({
                                    ...prev,
                                    status: checked
                                }))}
                            />

                        </div>
                    </div>
                </div>


                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-dark ms-2" type="button" onClick={() => onHide()} disabled={loading}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button className="btn btn-info ms-2" type="button" onClick={() => handleSave()} disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus me-2"></i> {actionText}
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DepartmentEditModal;
